var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShowConfirm,
          expression: "isShowConfirm"
        }
      ],
      staticClass: "small",
      attrs: {
        type: "description",
        title: _vm.$t("assets.notice.title"),
        close: _vm.closeConfirm,
        closeIcon: true,
        singleBtn: true,
        leftBtnTxt: _vm.$t("assets.notice.next"),
        leftBtnClick: _vm.next
      }
    },
    [
      _c("div", { staticClass: "notice-content" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t("assets.notice.contentProvider", {
                gate: _vm.gateInfo.gateway
              })
            ) +
            "\n        "
        ),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.gateInfo.gateway !== "Vite Labs",
                expression: "gateInfo.gateway !== 'Vite Labs'"
              }
            ]
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t("assets.notice.contentOther", {
                    gate: _vm.gateInfo.gateway
                  })
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t("assets.notice.contentAgree", {
                gate: _vm.gateInfo.gateway
              })
            ) +
            "\n        "
        ),
        _c(
          "span",
          {
            staticClass: "link __pointer",
            on: {
              click: function($event) {
                return _vm.goLink(_vm.gateInfo.privacy)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("assets.notice.agreement")))]
        ),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t("assets.notice.contentUngree", {
                gate: _vm.gateInfo.gateway
              })
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("assets.notice.hint", { gate: _vm.gateInfo.gateway })
              ) +
              "\n            "
          ),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.gateInfo.customer,
                  expression: "gateInfo.customer"
                }
              ]
            },
            [
              _vm._v("\n                --"),
              _c(
                "a",
                {
                  staticClass: "link __pointer",
                  on: {
                    click: function($event) {
                      return _vm.goLink(_vm.gateInfo.customer)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.gateInfo.customer))]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }